import { render, staticRenderFns } from "./MainBanner.vue?vue&type=template&id=54e9804a&"
import script from "./MainBanner.vue?vue&type=script&lang=js&"
export * from "./MainBanner.vue?vue&type=script&lang=js&"
import style0 from "./MainBanner.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports